/**
 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v21.0.1
 * @link http://www.ag-grid.com/
 * @license MIT
 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ChartType;
(function (ChartType) {
    ChartType[ChartType["GroupedBar"] = 0] = "GroupedBar";
    ChartType[ChartType["StackedBar"] = 1] = "StackedBar";
    ChartType[ChartType["Line"] = 2] = "Line";
    ChartType[ChartType["Pie"] = 3] = "Pie";
    ChartType[ChartType["Doughnut"] = 4] = "Doughnut";
})(ChartType = exports.ChartType || (exports.ChartType = {}));
